<template>
  <section class="store-manage">
    <div class="topDiv">
      <Form ref="searchForm" :model="searchForm" inline :label-width="0">
        <Row>
          <Col span="24">
            <FormItem>
              <Select
                filterable
                v-model="searchForm.dealerCode"
                placeholder="请选择经销商"
                style="width: 200px"
              >
                <Option
                  :key="index"
                  :value="item.elnDealerCode"
                  v-for="(item, index) in spInfoQueryAll"
                  >{{ item.elnDealerName }}</Option
                >
              </Select>
            </FormItem>
            <FormItem>
              <Input
                type="text"
                v-model="searchForm.searchKeyStr"
                clearable
                placeholder="门店名称/手机号/账号/联系人"
                style="width: 200px"
              />
            </FormItem>
            <FormItem>
              <Select
                filterable
                v-model="searchForm.retType"
                placeholder="请选择门店类型"
                style="width: 200px"
              >
                <Option
                  :key="index"
                  :value="item.code"
                  v-for="(item, index) in baseRetailerTypeList"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <span v-show="drop">
              <br />
              <FormItem>
                <Select
                  filterable
                  v-model="searchForm.select"
                  placeholder="请选择经销商"
                  style="width: 130px"
                >
                  <Option
                    :key="index"
                    :value="item.value"
                    v-for="(item, index) in optionList"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem>
                <Select
                  filterable
                  v-model="searchForm.select"
                  placeholder="请选择门店类型"
                  style="width: 130px"
                >
                  <Option
                    :key="index"
                    :value="item.code"
                    v-for="(item, index) in baseRetailerTypeList"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
              <FormItem>
                <Select
                  filterable
                  v-model="searchForm.select"
                  placeholder="请选择连锁中心"
                  style="width: 130px"
                >
                  <Option
                    :key="index"
                    :value="item.value"
                    v-for="(item, index) in optionList"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </span>
            <FormItem style="margin-left: 15px" class="br">
              <Button
                @click="handleSearch"
                type="primary"
                v-access="'store.manage.query'"
                >查询</Button
              >
              <Button
                @click="handleReset"
                style="margin-left: 10px"
                v-access="'store.manage.reset'"
                >重置</Button
              >
              <!-- <a
                  class="drop-down"
                  @click="dropDown"
                  style="margin-left: 20px"
                >
                  {{ dropDownContent }}
                  <Icon :type="dropDownIcon"></Icon>
                </a> -->
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="queryLogoBox">
        <img :src="queryUrl" alt="query" title="query" class="queryLogo" />
      </div>
    </div>
    <div class="bigbox">
      <div class="centerDiv">
        <div class="title">门店列表</div>
        <div>
          <Button-group style="margin-right: 10px">
            <Button @click="handleSearch">导出</Button>
            <Button @click="handleReset">导入</Button>
            <Button @click="handleDownload">下载</Button>
          </Button-group>
          <Button
            @click="handleAdd"
            type="primary"
            icon="md-add"
            v-access="'store.manage.add'"
            >添加</Button
          >
        </div>
      </div>

      <div class="tableBox">
        <Table
          :loading="loading"
          border
          :columns="columns"
          :data="dataSource"
          ref="table"
        ></Table>
      </div>

      <Row type="flex" justify="end" class="page">
        <Page
          :current="searchForm.page"
          :total="total"
          :page-size="searchForm.pageSize"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          :page-size-opts="[10, 20, 50]"
          show-total
          show-elevator
          show-sizer
        >
        </Page>
      </Row>
    </div>

    <Modal title="零售商信息审核" v-model="accountVisiable" @on-ok="handleAccountSave" @on-cancel="cancelAccountSave">
      <Form
        ref="accountSearchForm"
        :model="accountSearchForm"
        :label-width="100"
      >
          <FormItem label="状态">
            <Select
              v-model="accountSearchForm.status"
              placeholder="请选择状态"
              style="width: 300px"
            >
              <Option
                value="0"
                >审核通过</Option
              >
              <Option
                value="2"
                >流程驳回</Option
              >
            </Select>
          </FormItem>
          <FormItem label="备注">
            <Input style="width: 300px" v-model="accountSearchForm.remark" :maxlength="100" show-word-limit type="textarea" />
          </FormItem>
      </Form>
    </Modal>
  </section>
</template>

<script>
export default {
  name: "store-manage",
  created() {},
  data() {
    return {
      queryUrl: require("@/assets/query.png"),
      total: 0,
      drop: false,
      loading: false,
      accountVisiable: false,
      accountRetCode: "",
      dataSource: [],
      baseRetailerTypeList: [],
      wmsBaseQueryList: [],
      spInfoQueryAll: [],
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: {
        page: 1,
        pageSize: 10,
        dealerCode: "",
        searchKeyStr: "",
        retType: "",
      },
      accountSearchForm: {
        status: "0",
        remark: "",
      },
      optionList: [],
      columns: [
        {
          title: "序号",
          key: "id",
          width: 70,
          align: "center",
          type: "index",
          fixed: "left",
        },
        {
          title: "门店ID",
          key: "retCode",
          width: 220,
          align: "center",
          fixed: "left",
        },
        {
          title: "门店等级",
          key: "grade",
          width: 100,
          align: "center",
          ellipsis: true,
        },
        {
          title: "名称",
          key: "retName",
          width: 120,
          ellipsis: true,
          render: (h, params) => {
            const { row } = params;
            return h(
              "a",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => this.handleOpenDeatil(row.retCode),
                },
              },
              row.retName
            );
          },
        },
        {
          title: "门店类型",
          key: "retTypeName",
          width: 120,
          ellipsis: true,
        },

        {
          title: "联系人",
          key: "contacTperson",
          width: 100,
          ellipsis: true,
        },
        {
          title: "关联服务商",
          key: "fwName",
          width: 120,
          ellipsis: true,
        },
        {
          title: "创建时间",
          key: "createTime",
          width: 150,
          ellipsis: true,
        },
        {
          title: "状态",
          key: "status",
          width: 150,
          render: (h, params) => {
            const { row, index } = params;
            let val = row.status === '0'?true:false;
            return h(
              "i-switch",
              {
                props: {
                  value: val,
                },
                on:{
                  'on-change':(val) => {
                    this.changeStatus(row, index, val);
                  }
                }
              },[
              h('Option',{props:{value:'0'}},'正常'),
              h('Option',{props:{value:'1'}},'停用'),
              h('Option',{props:{value:'2'}},'审核失败'),
              h('Option',{props:{value:'3'}},'冻结'),
              h('Option',{props:{value:'4'}},'关店'),
              h('Option',{props:{value:'5'}},'待审核'),
              h('Option',{props:{value:'6'}},'门店已被注册'),
              ],
              ""
            );
          },
        },
        {
          title: "操作",
          key: "retCode",
          width: 120,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const { row } = params;
            return h("div", [
              h(
                "a",
                {
                  directives: [
                    {
                      name: "access",
                      value: "store.manage.edit",
                    },
                  ],
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => this.handleOpenEdit(row.retCode),
                  },
                },
                "编辑"
              ),
              row.status == "5"
                ? h(
                    "a",
                    {
                      directives: [
                        {
                          name: "access",
                          value: "store.manage.edit",
                        },
                      ],
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      on: {
                        click: () => {
                          this.accountVisiable = true;
                          this.accountRetCode = row.retCode;
                        },
                      },
                    },
                    "开通账号"
                  )
                : null,
            ]);
          },
        },
      ],
      retailerTypeQueryList: [
        { label: "直接订货门店", value: "0" },
        { label: "总仓配货门店", value: "1" },
        { label: "总仓和门店", value: "2" },
        { label: "总仓", value: "3" },
        { label: "联盟总店", value: "21" },
        { label: "联盟分店", value: "22" },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getInfoList();
      this.getBaseRetailerType();
      this.getWmsBaseQueryList();
      this.getSpInfoQueryAll();
    },
    async getSpInfoQueryAll() {
      const { data } = await this.$api["spInfoQueryAll"]();
      this.spInfoQueryAll = data;
    },
    async getWmsBaseQueryList() {
      const { data } = await this.$api["wmsBaseQueryList"]({});
      this.wmsBaseQueryList = data;
    },
    async getBaseRetailerType() {
      const { data } = await this.$api["baseRetailerTypQqueryAll"]();
      this.baseRetailerTypeList = data;
    },
    async getInfoList(params = {}) {
      const { data, total } = await this.$api["shopInfoQueryList"](params);
      data.forEach((d) => {
        let con = this.retailerTypeQueryList.filter(
          (s) => s.value == d.retType
        );
        if (con.length) {
          d.retTypeName = con[0].label;
        }
      });
      this.dataSource = data;
      this.total = total;
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    handleSearch() {
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      const params = {
        ...this.searchForm,
      };
      this.getInfoList(params);
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      this.searchForm.dealerCode = "";
      this.searchForm.searchKeyStr = "";
      this.searchForm.retType = "";
      this.getInfoList();
    },
    handleDownload() {},
    handleAdd() {
      this.$router.push({
        path: "edit",
      });
    },
    async hanldeSwitch(status, retCode = "") {
      return new Promise(async (resolve, reject) => {
        try {
          const params = {
            retCode: retCode,
            status: !status ? "1" : "2",
          };
          const { data, code } = await this.$api["shopInfoEnable"](params);
          if (code == "200") {
            this.$Message.success("状态修改成功");
            this.getInfoList();
            resolve();
          }
        } catch (err) {
          this.$Message.error("状态修改失败");
          reject();
        }
      });
    },
    async handleAccountSave() {
      try {
        const params = {
          ...this.accountSearchForm,
          retCode: this.accountRetCode,
        };
        const { data, code } = await this.$api["shopInfoAudit"](params);
        if (code == "200") {
          this.accountSearchForm.status = "0";
          this.accountSearchForm.remark = "";
          this.accountVisiable = false;
          this.$Message.success("门店开通成功");
          this.getInfoList();
        } else {
          this.$Message.error("门店开通失败");
        }
      } catch (err) {
        this.$Message.error("门店开通失败");
      }
    },
    cancelAccountSave() {
      this.accountSearchForm.status = "0";
      this.accountSearchForm.remark = "";
      this.accountVisiable = false;
    },
    handleOpenEdit(v) {
      this.$router.push({
        path: "edit",
        query: {
          retCode: v,
        },
      });
    },
    handleOpenDeatil(v) {
      this.$router.push({
        path: "detail",
        query: {
          retCode: v,
        },
      });
    },
    changePage(v) {
      this.searchForm.page = v;
      this.getInfoList(this.searchForm);
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getInfoList(this.searchForm);
    },
    changeStatus(row, index, status) {
      this.$api["switchStatus"]({retCode:row.retCode, status:status?'0':'4'}).then((res) => {
	 if(res.code == '200'){
         row.status = status;
         }
         this.dataSource.splice(index,1,row);
      }).catch(()=>{
         this.dataSource.splice(index,1,row);
      });
    }
  },
};
</script>

<style>
.store-manage {
  background: #f0f2f5;
  margin: -24px -20px;
  height: 100%;
}
.store-manage .topDiv {
  padding: 24px 24px 0;
  background: #fff;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0px 0px 6px 0px #e2e2f8;
  border-radius: 8px;
}
.store-manage .bigbox {
  background: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 24px 20px;
}
.store-manage .centerDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
}
.store-manage .centerDiv .title {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
}
.store-manage .ivu-row-flex-end {
  background: #fff;
  padding: 20px 20px 0;
}
.queryLogo {
  width: 20px;
  height: 20px;
}
.queryLogoBox {
  cursor: pointer;
  width: 38px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeManage.vue